/**
 * Sidebar footer line. While a tenant's own logo is live it reads "Powered by
 * AskWingo" (XC-ERP1-U11 §2.2, ruling G25); otherwise the version line.
 */

import { useCustomLogoLive } from '@/hooks/data/useTenantBranding';
import React from 'react';

export const BrandAttribution: React.FC = () => {
  const customLogoLive = useCustomLogoLive();
  return (
    <div className="text-center text-[11px] text-gray-400">
      <p>{customLogoLive ? 'Powered by AskWingo' : 'AskWingo v0.1.0'}</p>
    </div>
  );
};
